export default __webpack_public_path__ + "static/logocolor-dcd815feae18647fb91930284f10822d.svg";